import useSWR from 'swr'

// libs
import { apiGetService, apiHandleError } from '@/lib'

// types
import { SWRKeys, SWRFetcherData } from './types'

const getTrack = async ({ data: { trackId } }: SWRFetcherData<{ trackId: string }>) => {
  // get api service
  const api = apiGetService()

  try {
    // retrieve track
    const { track } = await api.trackApi.getTrack(trackId)

    // return payload
    return { track, error: '' }
  } catch (err: any) {
    const { message } = await apiHandleError(err)

    // return payload
    return { track: undefined, error: message }
  }
}

const fetcher = (args: SWRFetcherData<{ trackId: string }>) => getTrack(args)

export const useTrack = (trackId: string) => {
  const shouldFetch = !!trackId

  const { data, isLoading, mutate } = useSWR(
    shouldFetch ? { key: SWRKeys.UseTrack, data: { trackId } } : null,
    fetcher,
    { revalidateOnFocus: false },
  )

  return {
    track: data?.track,
    isLoading,
    isError: data?.error,
    mutate,
  }
}
